/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class RenderContextImpl
 * @hideconstructor
 * @classdesc Implements {@link RenderContextAPI}
 */
define([], () => {
	class RenderContextImpl {

		/**
		 * 
		 * @param {Object} options - init paramaters
		 * @param {Object} options.renderContext - renderContext used internally
		 */
		constructor(options) {
			this._renderContext = options.renderContext;
			this._logger = options.logger;
		}

		/**
		 * @implements RenderContextAPI.getSequenceId
		 */
		getSequenceId() {
			return this._renderContext.id;
		}

		/**
		 * @implements RenderContextAPI.getData
		 */
		getData(name) {
			return this._renderContext[name];
		}

	}

	return RenderContextImpl;
});